import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React from "react";
import PropTypes from "prop-types";
import * as stylex from "@stylexjs/stylex";
import { lineSpinner } from "ldrs";
lineSpinner.register();
export default function SpinnerApple(props) {
  var _props$size, _props$strokeSize, _props$color;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("l-line-spinner", {
    size: (_props$size = props.size) !== null && _props$size !== void 0 ? _props$size : 16,
    stroke: (_props$strokeSize = props.strokeSize) !== null && _props$strokeSize !== void 0 ? _props$strokeSize : 1,
    speed: 0.8,
    color: (_props$color = props.color) !== null && _props$color !== void 0 ? _props$color : '#a5a5a5'
  }), props.caption && /*#__PURE__*/React.createElement("div", null, props.caption));
}
SpinnerApple.propTypes = {
  caption: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number
};

// @ts-ignore
_inject(".ev1rg5ohu{display:inline-block}", 3000);
_inject(".ev6jxa94{width:14px}", 4000);
_inject(".ev1v9usgg{height:14px}", 4000);
_inject(".ev8xkuhf{background-size:14px 14px}", 3000);
_inject(".ev1lvsgvq{background-position:center center}", 2000);
_inject(".eviy17q3{background-repeat:no-repeat}", 3000);
_inject(".evmkeg23{border-width:1px}", 2000);
_inject(".ev1y0btm7{border-style:solid}", 2000);
_inject(".ev71xlcl{border-color:red}", 2000);